<template>
  <v-snackbar v-model="snackbarState" :left="x === 'left'" :timeout="timeout" :bottom="y === 'bottom'" :color="color">
    {{ text }}
    <v-btn class="white--text" flat @click="hideSnackbar" icon>
      <v-icon>fal fa-times</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  model: {
    prop: 'snackbar',
    event: 'snackbar'
  },
  props: {
    snackbar: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    },
    color: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      y: 'bottom',
      x: 'left',
      timeout: 4000,
      snackbarState: this.snackbar
    }
  },
  watch: {
    snackbar(val) {
      this.snackbarState = val
    },
    snackbarState(val) {
      this.$emit('snackbar', val)
    }
  },
  methods: {
    hideSnackbar() {
      this.snackbarState = false;
    }
  }
}
</script>